"use client"

import { useState, useEffect, useRef } from "react"
import styles from "../styles/gateway.module.css"
import paymentGatewayImage from "../assets/paymGateway.jpg"
import { Link } from "react-router-dom"
import Header from "../components/Header"
import view from "../assets/gateway1.png"
import Footer from "../components/Footer"

const PaymentGatewaySection = () => {
  const [isMac, setIsMac] = useState(false)
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const featuresSectionRef = useRef(null)

  const features = [
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M35.5632 38.625H20.2507C16.4001 38.625 14.4768 38.625 13.2804 37.4286C12.084 36.2322 12.084 34.3089 12.084 30.4583V22.2917C12.084 18.4411 12.084 16.5178 13.2804 15.3214C14.4768 14.125 16.4001 14.125 20.2507 14.125H44.7507C48.6012 14.125 50.5245 14.125 51.7209 15.3214C52.9173 16.5178 52.9173 18.4411 52.9173 22.2917V32.5C52.9173 34.4028 52.9173 35.3543 52.607 36.1035C52.4018 36.5993 52.1009 37.0497 51.7215 37.4291C51.3421 37.8085 50.8916 38.1095 50.3959 38.3147C49.6466 38.625 48.6952 38.625 46.7923 38.625"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Recurring Payments",
      description:
        "Set up automated billing cycles for subscription services or installment-based sales where you can ensure timely collections from customers.",
    },
    {
      icon: () => (
        <svg width="66" height="65" viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32.4975 46.9644V53.393M40.5332 43.7501V50.1787M24.4618 43.7501V50.1787M35.9175 20.8934C35.7344 20.3698 35.3927 19.9163 34.9399 19.596C34.4871 19.2757 33.9457 19.1045 33.3911 19.1062H31.3178C30.7299 19.1083 30.1633 19.3269 29.7263 19.7203C29.2893 20.1137 29.0126 20.6543 28.949 21.2389C28.8853 21.8234 29.0393 22.4109 29.3814 22.8891C29.7235 23.3673 30.2298 23.7027 30.8036 23.8312L33.9632 24.5255C34.6066 24.669 35.1745 25.0445 35.5586 25.5802C35.9426 26.116 36.1158 26.7744 36.045 27.4298C35.9742 28.0852 35.6644 28.6915 35.1748 29.1329C34.6853 29.5743 34.0502 29.8199 33.3911 29.8226H31.6039C31.0493 29.8243 30.5079 29.6531 30.0551 29.3328C29.6023 29.0125 29.2606 28.559 29.0775 28.0355M32.4975 19.1062V16.4287M32.4975 32.5001V29.8226M18.8368 25.268C18.6237 25.268 18.4193 25.1833 18.2686 25.0326C18.1179 24.8819 18.0332 24.6775 18.0332 24.4644C18.0332 24.2513 18.1179 24.0469 18.2686 23.8962C18.4193 23.7455 18.6237 23.6609 18.8368 23.6609C19.0499 23.6609 19.2543 23.7455 19.405 23.8962C19.5557 24.0469 19.6403 24.2513 19.6403 24.4644C19.6403 24.6775 19.5557 24.8819 19.405 25.0326C19.2543 25.1833 19.0499 25.268 18.8368 25.268ZM46.1582 25.268C45.9451 25.268 45.7407 25.1833 45.59 25.0326C45.4393 24.8819 45.3546 24.6775 45.3546 24.4644C45.3546 24.2513 45.4393 24.0469 45.59 23.8962C45.7407 23.7455 45.9451 23.6609 46.1582 23.6609C46.3713 23.6609 46.5757 23.7455 46.7264 23.8962C46.8771 24.0469 46.9618 24.2513 46.9618 24.4644C46.9618 24.6775 46.8771 24.8819 46.7264 25.0326C46.5757 25.1833 46.3713 25.268 46.1582 25.268Z"
            stroke="#A6DC94"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.1769 11.6074H14.8198C13.9673 11.6074 13.1497 11.9461 12.5469 12.5489C11.9441 13.1517 11.6055 13.9692 11.6055 14.8217V34.1074C11.6055 34.9599 11.9441 35.7775 12.5469 36.3803C13.1497 36.9831 13.9673 37.3217 14.8198 37.3217H50.1769C51.0294 37.3217 51.8469 36.9831 52.4497 36.3803C53.0525 35.7775 53.3912 34.9599 53.3912 34.1074V14.8217C53.3912 13.9692 53.0525 13.1517 52.4497 12.5489C51.8469 11.9461 51.0294 11.6074 50.1769 11.6074Z"
            stroke="#A6DC94"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Bulk Payments",
      description: "Disburse multiple payments in one go ideal for payroll, partner payouts, or vendor payments.",
    },
    {
      icon: () => (
        <svg width="66" height="65" viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M39.127 19.375V23.125M39.127 30.625V34.375M39.127 41.875V45.625M20.377 19.375H46.627C47.6215 19.375 48.5753 19.7701 49.2786 20.4733C49.9819 21.1766 50.377 22.1304 50.377 23.125V28.75C49.3824 28.75 48.4286 29.1451 47.7253 29.8484C47.022 30.5516 46.627 31.5054 46.627 32.5C46.627 33.4946 47.022 34.4484 47.7253 35.1516C48.4286 35.8549 49.3824 36.25 50.377 36.25V41.875C50.377 42.8696 49.9819 43.8234 49.2786 44.5266C48.5753 45.2299 47.6215 45.625 46.627 45.625H20.377C19.3824 45.625 18.4286 45.2299 17.7253 44.5266C17.022 43.8234 16.627 42.8696 16.627 41.875V36.25C17.6215 36.25 18.5753 35.8549 19.2786 35.1516C19.9819 34.4484 20.377 33.4946 20.377 32.5C20.377 31.5054 19.9819 30.5516 19.2786 29.8484C18.5753 29.1451 17.6215 28.75 16.627 28.75V23.125C16.627 22.1304 17.022 21.1766 17.7253 20.4733C18.4286 19.7701 19.3824 19.375 20.377 19.375Z"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Split Payments",
      description:
        "Easily divide transactions between multiple parties or accounts, streamlining commission-based models.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M27.7739 47.5395C26.9984 48.2445 26.1974 49.114 25.8704 49.159C25.5434 49.2041 25.2026 48.9945 24.4721 48.5813L20.7474 46.482C19.8074 46.012 19.7604 45.6595 19.7604 45.542C19.7604 45.4245 19.7604 44.9271 20.0659 43.9048C21.0451 40.137 18.7499 36.142 14.8509 35.1237C13.8286 34.8495 13.3175 34.7104 13.1158 34.4461C12.9141 34.1817 12.9141 33.7607 12.9141 32.9107V29.1449C12.9141 28.2969 12.9141 27.8719 13.1158 27.6095C13.3175 27.3452 13.8286 27.2081 14.8509 26.9319C18.6696 25.9019 21.0627 22.0204 20.0796 18.2272C19.8054 17.1834 19.6723 16.6605 19.8015 16.355C19.9308 16.0495 20.3009 15.838 21.0451 15.415L24.4232 13.4978C25.1517 13.0865 25.5159 12.877 25.843 12.922C26.17 12.9651 26.5382 13.3333 27.2765 14.0716C30.1356 16.9209 34.8631 16.9209 37.7203 14.0716C38.4586 13.3352 38.8287 12.9671 39.1557 12.922C39.4828 12.8789 39.847 13.0846 40.5755 13.4997L43.9536 15.4169C44.6978 15.838 45.0679 16.0495 45.1972 16.3569C45.3264 16.6605 45.1913 17.1834 44.9191 18.2272C43.9341 22.0204 46.3252 25.9234 50.1439 26.9535C51.1662 27.2277 51.6773 27.3706 51.879 27.635C52.0807 27.8994 52.0807 28.7375 52.0807 29.5855M38.3724 42.722C38.3724 42.722 40.3307 43.2782 41.3099 45.2365C41.3099 45.2365 43.4562 40.3407 46.2214 39.3615"
            stroke="#A6DC94"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.1347 27.2129C37.4812 26.3084 36.6234 25.5709 35.6311 25.0605C34.6388 24.55 33.5401 24.281 32.4242 24.2754C28.8992 24.3224 25.6797 27.2325 25.6797 31.0199C25.6797 33.1075 26.2672 34.6154 27.9122 36.2604M52.078 42.2921C52.078 44.889 51.0464 47.3795 49.2101 49.2158C47.3738 51.0521 44.8833 54.0425 42.2864 54.0422C39.6894 54.0422 37.1989 53.0106 35.3626 51.1743C33.5263 49.338 32.4947 46.8475 32.4947 44.2505C32.4947 41.6536 33.5263 39.1631 35.3626 37.3268C37.1989 35.4905 39.6894 34.4589 42.2864 34.4589C44.8833 34.4589 47.3738 35.4905 49.2101 37.3268C51.0464 39.1631 52.078 41.6536 52.078 44.2505Z"
            stroke="#A6DC94"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Event Payment Integration",
      description: "Plan, promote, and get paid for events with secure and smooth payment workflows.",
    },
    {
      icon: () => (
        <svg width="66" height="65" viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M48.3818 24.6672H50.4616C51.5004 24.6672 52.4966 25.0798 53.2311 25.8143C53.9656 26.5488 54.3783 27.5451 54.3783 28.5838V36.4172C54.3783 37.4559 53.9656 38.4521 53.2311 39.1867C52.4966 39.9212 51.5004 40.3338 50.4616 40.3338H48.3818C47.9048 44.12 46.0623 47.602 43.2 50.126C40.3378 52.65 36.6527 54.0425 32.8366 54.0422V50.1255C35.9529 50.1255 38.9415 48.8876 41.1451 46.684C43.3486 44.4805 44.5866 41.4918 44.5866 38.3755V26.6255C44.5866 23.5092 43.3486 20.5205 41.1451 18.317C38.9415 16.1134 35.9529 14.8755 32.8366 14.8755C29.7203 14.8755 26.7316 16.1134 24.5281 18.317C22.3245 20.5205 21.0866 23.5092 21.0866 26.6255V40.3338H15.2116C14.1728 40.3338 13.1766 39.9212 12.4421 39.1867C11.7076 38.4521 11.2949 37.4559 11.2949 36.4172V28.5838C11.2949 27.5451 11.7076 26.5488 12.4421 25.8143C13.1766 25.0798 14.1728 24.6672 15.2116 24.6672H17.2913C17.7692 20.8815 19.6121 17.4003 22.4742 14.8768C25.3363 12.3533 29.0209 10.9609 32.8366 10.9609C36.6523 10.9609 40.3369 12.3533 43.199 14.8768C46.0611 17.4003 47.9039 20.8815 48.3818 24.6672ZM15.2116 28.5838V36.4172H17.1699V28.5838H15.2116ZM48.5033 28.5838V36.4172H50.4616V28.5838H48.5033ZM24.5333 39.9128L26.6091 36.5915C28.4754 37.7608 30.6341 38.3793 32.8366 38.3755C35.039 38.3793 37.1977 37.7608 39.0641 36.5915L41.1399 39.9128C38.6515 41.4722 35.7732 42.297 32.8366 42.2922C29.8999 42.297 27.0217 41.4722 24.5333 39.9128Z"
            fill="#A6DC94"
          />
        </svg>
      ),
      title: "Group payment link",
      description: "From many to one-collect group payments through a single, intelligent link",
    },
    {
      icon: () => (
        <svg width="66" height="65" viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M46.8743 23.6882C49.5782 23.6882 51.7702 21.4962 51.7702 18.7923C51.7702 16.0884 49.5782 13.8965 46.8743 13.8965C44.1705 13.8965 41.9785 16.0884 41.9785 18.7923C41.9785 21.4962 44.1705 23.6882 46.8743 23.6882Z"
            stroke="#A6DC94"
            strokeWidth="3"
          />
          <path
            d="M51.278 28.5846V38.8659C51.278 41.9822 50.0401 44.9708 47.8365 47.1744C45.6329 49.3779 42.6443 50.6159 39.528 50.6159H26.7988C23.6825 50.6159 20.6939 49.3779 18.4903 47.1744C16.2868 44.9708 15.0488 41.9822 15.0488 38.8659V26.1367C15.0488 23.0204 16.2868 20.0318 18.4903 17.8282C20.6939 15.6247 23.6825 14.3867 26.7988 14.3867H37.0801"
            stroke="#A6DC94"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.9004 38.4637L28.2185 32.7179C28.4829 32.3641 28.8706 32.1225 29.3047 32.0409C29.7388 31.9593 30.1878 32.0436 30.5626 32.2773L34.775 34.9387C35.1643 35.1866 35.6352 35.2719 36.0867 35.1763C36.5382 35.0807 36.9342 34.8119 37.1896 34.4276L41.5254 27.8867"
            stroke="#A6DC94"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "International payment support",
      description: "Our platform supports secure international payments across multiple currencies",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0833 32.5C12.0833 22.1158 20.4008 13.7917 30.785 13.7917C35.9818 13.7917 40.285 15.8642 43.1492 19.1417L44.8258 21.0267M52.9167 32.5C52.9167 42.8842 44.5992 51.2083 34.215 51.2083C29.0182 51.2083 24.715 49.1358 21.8508 45.8583L20.1742 43.9733"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.5 13.7917V17.875M32.5 47.125V51.2083M13.7917 32.5H17.875M47.125 32.5H51.2083M20.893 20.893L23.7214 23.7214M41.279 41.279L44.1074 44.1074M20.893 44.107L23.7214 41.2786M41.279 23.721L44.1074 20.8926"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Payment Link Generation",
      description: "Vendors can create sharable links to request payment from anyone.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.2917 12.0833H42.7083C45.2417 12.0833 46.5083 12.0833 47.2831 12.8581C48.0579 13.6329 48.0579 14.8995 48.0579 17.4329V47.5671C48.0579 50.1005 48.0579 51.3671 47.2831 52.1419C46.5083 52.9167 45.2417 52.9167 42.7083 52.9167H22.2917C19.7583 52.9167 18.4917 52.9167 17.7169 52.1419C16.9421 51.3671 16.9421 50.1005 16.9421 47.5671V17.4329C16.9421 14.8995 16.9421 13.6329 17.7169 12.8581C18.4917 12.0833 19.7583 12.0833 22.2917 12.0833Z"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.4583 45.4167H34.5417"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Checkout Options",
      description: "Payments at checkout, direct payments, payment links, and bulk or group payments.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0833 32.5C12.0833 22.1158 20.4008 13.7917 30.785 13.7917C35.9818 13.7917 40.285 15.8642 43.1492 19.1417L44.8258 21.0267M52.9167 32.5C52.9167 42.8842 44.5992 51.2083 34.215 51.2083C29.0182 51.2083 24.715 49.1358 21.8508 45.8583L20.1742 43.9733"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.5 13.7917V17.875M32.5 47.125V51.2083M13.7917 32.5H17.875M47.125 32.5H51.2083M20.893 20.893L23.7214 23.7214M41.279 41.279L44.1074 44.1074M20.893 44.107L23.7214 41.2786M41.279 23.721L44.1074 20.8926"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Wallet Integration",
      description: "Integrates with wallets like Telebirr, MPesa, CBEbirr and Yaya wallet for local wallet payments.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M35.5632 38.625H20.2507C16.4001 38.625 14.4768 38.625 13.2804 37.4286C12.084 36.2322 12.084 34.3089 12.084 30.4583V22.2917C12.084 18.4411 12.084 16.5178 13.2804 15.3214C14.4768 14.125 16.4001 14.125 20.2507 14.125H44.7507C48.6012 14.125 50.5245 14.125 51.7209 15.3214C52.9173 16.5178 52.9173 18.4411 52.9173 22.2917V32.5C52.9173 34.4028 52.9173 35.3543 52.607 36.1035C52.4018 36.5993 52.1009 37.0497 51.7215 37.4291C51.3421 37.8085 50.8916 38.1095 50.3959 38.3147C49.6466 38.625 48.6952 38.625 46.7923 38.625"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Merchant Dashboard",
      description:
        "A user-friendly interface where vendors can monitor transactions, view balances, manage settlement accounts, and export reports.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.2917 12.0833H42.7083C45.2417 12.0833 46.5083 12.0833 47.2831 12.8581C48.0579 13.6329 48.0579 14.8995 48.0579 17.4329V47.5671C48.0579 50.1005 48.0579 51.3671 47.2831 52.1419C46.5083 52.9167 45.2417 52.9167 42.7083 52.9167H22.2917C19.7583 52.9167 18.4917 52.9167 17.7169 52.1419C16.9421 51.3671 16.9421 50.1005 16.9421 47.5671V17.4329C16.9421 14.8995 16.9421 13.6329 17.7169 12.8581C18.4917 12.0833 19.7583 12.0833 22.2917 12.0833Z"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.4583 45.4167H34.5417"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Refund Management",
      description: "Merchants can allow full or partial refunds when necessary.",
    },
    {
      icon: () => (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0833 32.5C12.0833 22.1158 20.4008 13.7917 30.785 13.7917C35.9818 13.7917 40.285 15.8642 43.1492 19.1417L44.8258 21.0267M52.9167 32.5C52.9167 42.8842 44.5992 51.2083 34.215 51.2083C29.0182 51.2083 24.715 49.1358 21.8508 45.8583L20.1742 43.9733"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.5 13.7917V17.875M32.5 47.125V51.2083M13.7917 32.5H17.875M47.125 32.5H51.2083M20.893 20.893L23.7214 23.7214M41.279 41.279L44.1074 44.1074M20.893 44.107L23.7214 41.2786M41.279 23.721L44.1074 20.8926"
            stroke="#A6DC94"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Developer-Friendly APIs",
      description: "Easy-to-integrate APIs with detailed documentation and sandbox support.",
    },
  ]

  useEffect(() => {
    if (navigator.platform.toLowerCase().includes("mac")) {
      setIsMac(true)
    }
  }, [])

  // Add proper mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const scrollToTop = () => {
    if (featuresSectionRef.current && isMobile) {
      featuresSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
  }

  // Fixed navigation logic with proper bounds checking
  const handleNext = () => {
    if (isMobile) {
      // Mobile: move one item at a time, stop at last item
      setCurrentFeatureIndex((prev) => {
        const nextIndex = prev + 1
        return nextIndex < features.length ? nextIndex : prev
      })
    } else {
      // Desktop: move by 6, stop when we can't show a full set of 6
      setCurrentFeatureIndex((prev) => {
        const nextIndex = prev + 6
        return nextIndex < features.length ? nextIndex : prev
      })
    }
  }

  const handlePrev = () => {
    if (isMobile) {
      // Mobile: move back one item, stop at first item
      setCurrentFeatureIndex((prev) => {
        const prevIndex = prev - 1
        return prevIndex >= 0 ? prevIndex : prev
      })
    } else {
      // Desktop: move back by 6, stop at beginning
      setCurrentFeatureIndex((prev) => {
        const prevIndex = prev - 6
        return prevIndex >= 0 ? prevIndex : prev
      })
    }
  }

  // Check if buttons should be disabled
  const isPrevDisabled = currentFeatureIndex === 0
  const isNextDisabled = isMobile
    ? currentFeatureIndex >= features.length - 1
    : currentFeatureIndex >= features.length - 6

  // Fixed function to get displayed features
  const getDisplayedFeatures = () => {
    if (isMobile) {
      // Mobile - show only current feature
      return [features[currentFeatureIndex]]
    } else {
      // Desktop - show 6 features starting from currentFeatureIndex
      const endIndex = Math.min(currentFeatureIndex + 6, features.length)
      return features.slice(currentFeatureIndex, endIndex)
    }
  }

  const displayedFeatures = getDisplayedFeatures()

  return (
    <div className={styles.paymemnt}>
      <Header />
      <section className={styles.paymentGatewaySection}>
        <div className={styles.heroContent}>
          <p className={styles.tagline}>ARIF ONLINE PAYMENT</p>
          <h1 className={styles.heroTitle}>Best Online Payment Gateway in Ethiopia</h1>
          <p className={styles.heroSubtitle}>
            Arifpay is a leading online payment service provider in Ethiopia. Whether you're a startup or a nationwide enterprise,
            <br /> accept  wallets, cards and bank transfers through a secure, scalable checkout.
          </p>
          <div className={styles.heroButtons}>
            <Link to="/gatewayIntegration">
              <button className={styles.integrationButton}>
                Jump into integration <span className={styles.arrow}>→</span>
              </button>
            </Link>
          </div>
        </div>
        <div className={styles.heroImageContainer}>
          <img
            style={{ width: "697px" }}
            src={paymentGatewayImage || "/placeholder.svg"}
            alt="Payment Gateway Illustration"
            className={styles.heroImage}
          />
        </div>
        <div className={styles.heroContent}>
          <p className={styles.tagline}>WHY ARIFPAY?</p>
          <h1 className={styles.heroTitle}>
            <span style={{ color: "lightgreen" }}>Simple</span>,<span style={{ color: "lightgreen" }}>Secure</span>, And{" "}
            <span style={{ color: "lightgreen" }}>Tailored</span>
            <br />
            Solutions for Every Business
          </h1>
          <p style={{ fontFamily: "'DM'san-serif" }} className={styles.heroSubtitle}>
            No one-size-fits-all here. We understand your needs, listen closely, and deliver customized payment
            <br />
            solutions that move your business forward.
          </p>
        </div>
        <section>
          <div className={styles.newContent} style={{ display: "flex", alignItems: "center" }}>
            <div
              className={styles.solutionImage}
              style={{ position: "relative", display: "inline-block", marginTop: "50px" }}
            >
              <div className={styles.imageContainer}>
                <img
                  src={view || "/placeholder.svg"}
                  alt="feature payment"
                  style={{
                    maxWidth: "450px",
                    height: "300px",
                    display: "block",
                    borderRadius: "15px",
                    marginLeft: "20px",
                  }}
                />
              </div>
            </div>
            <div className={styles.viewText} style={{ flex: 1, marginRight: "40px", fontSize: "12px" }}>
              <h2 style={{ fontSize: "30px", color: "#333" }}>Built for Growth</h2>
              <p style={{ fontSize: "16px", color: "black", marginBottom: "5px", fontFamily: "'DM'san-serif" }}>
                Our platform combines smart tools and real-time insights, helping you optimize customer relationships,
                sales, and operational efficiency.
              </p>
            </div>
          </div>
        </section>
      </section>

      <section className={styles.keyFeaturesSection} ref={featuresSectionRef}>
        <div className={styles.header}>
          <h2 className={styles.mainHeading}>Key Features</h2>
        </div>
        <div className={styles.featuresContainer}>
          <button
            onClick={handlePrev}
            disabled={isPrevDisabled}
            className={`${styles.navButton} ${styles.leftButton} ${isPrevDisabled ? styles.disabled : ""}`}
            style={{
              opacity: isPrevDisabled ? 0.5 : 1,
              cursor: isPrevDisabled ? "not-allowed" : "pointer",
            }}
          >
            &#8249;
          </button>
          <div className={styles.centeredFeaturesGrid}>
            {displayedFeatures.map((feature, index) => (
              <div key={`${currentFeatureIndex}-${index}`} className={styles.featureCard}>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`${styles.navButton} ${styles.rightButton} ${isNextDisabled ? styles.disabled : ""}`}
            style={{
              opacity: isNextDisabled ? 0.5 : 1,
              cursor: isNextDisabled ? "not-allowed" : "pointer",
            }}
          >
            &#8250;
          </button>
        </div>

        {/* Add feature counter for mobile */}
        {isMobile && (
          <div style={{ textAlign: "center", marginTop: "20px", color: "#666" }}>
            {currentFeatureIndex + 1} of {features.length}
          </div>
        )}
      </section>

      <section style={{ backgroundColor: "white", textAlign: "center" }}>
        <div>
          <div className={styles.tailored}>
            <h2 className={styles.heroTitles} style={{ textAlign: "center", fontSize: "25px" }}>
              Tailored Support for Diverse
              <br />
              Businesses
            </h2>
            <p
              className={styles.heroSubtitles}
              style={{ color: "black", textAlign: "center", fontSize: "17px", fontFamily: "sans-serif" }}
            >
              No matter your size or industry, Arifpay delivers end-to-end support from integration and
             <span className={styles.lageBreak}> <br /></span>
              deployment to continuous maintenance. Let us handle the tech while you focus on what you do best.
              <br />
              <span style={{ color: "gray", fontSize: "1em" }}>
                <br />
                "with Arifpay, RetailMax transformed its operations with real-time analytics and minimal disruption
                <br />
                to daily business."
              </span>
            </p>
          </div>
          <div className={styles.head}>
            <h2 style={{ textAlign: "center", marginTop: "70px", fontSize: "1.8em" }}>How it works?</h2>
          </div>
          <div className={styles.ourSolutionsSliderContainer}>
            <div className={styles.solutionBox}>
              <p style={{ fontSize: "16px", color: "green" }}>1</p>
              <h3 style={{ fontSize: "22px" }}>Custom Design</h3>
              <p style={{ color: "black", fontSize: "18px" }}>
                We understand your business and craft a tailored payment journey.
              </p>
            </div>
            <div className={styles.solutionBox}>
              <p style={{ fontSize: "20px", color: "green" }}>2</p>
              <h3 style={{ fontSize: "20px" }}>Fast Integration</h3>
              <p style={{ color: "black", fontSize: "16px" }}>From APIs to plugins, we make the switch easy.</p>
            </div>
            <div className={styles.solutionBox}>
              <p style={{ fontSize: "20px", color: "green" }}>3</p>
              <h3 style={{ fontSize: "20px" }}>Reliable Deployment</h3>
              <p style={{ color: "black", fontSize: "16px" }}>Through testing, training, and rollout support.</p>
            </div>
            <div className={styles.solutionBox}>
              <p style={{ fontSize: "20px", color: "green" }}>4</p>
              <h3 style={{ fontSize: "20px" }}>Ongoing Support</h3>
              <p style={{ color: "black", fontSize: "16px" }}>
                Get help when you need it, with expert technical and customer assistance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div className={styles.bottom} style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2 style={{ fontSize: "30px", marginBottom: "15px", color: "white" }}>Start Integration Now</h2>
              <p style={{ fontSize: "16px" }}>
                <span style={{ color: "white", fontSize: "1em" }}>✦</span> Take the next step toward smarter commerce.
                Arifpay makes it easy to <br />
                integrate our payment solutions into your system quickly and securely.
                <br />
                Whether you're using a custom-built platform or popular tools, we offer
                <br />
                simple documentation and hands-on support to get you up and running.
              </p>
            </div>
            <div style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}>
              <img
                src={view || "/placeholder.svg"}
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default PaymentGatewaySection
